import React from 'react';
import { api } from "@/apps/common/api-client";
import { FormInput, PageTitle, VerticalForm } from "@/apps/common/components/";
import { MemberServiceContext } from "@/apps/common/components/contexts/MemberServiceContext";
import { ServiceType } from "@/apps/common/types/appointment-types";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRequest } from "ahooks";
import { AxiosError } from "axios";
import { useContext, useState, useMemo, useCallback, useRef } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CoachSkyler } from "@/apps/common/components/ChatBot/CoachSkyler";
import { useParams } from 'react-router-dom';


export default function SkylerChat() {

  //const { id } = useParams();
  const params = useParams();

  const id = useRef<string|null>();
 
  //const { refreshMemberService } = useContext(MemberServiceContext);
  //const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const chatSessionId = useMemo(() => {
    //console.debug (`SkylerChat chatSessionId - ${JSON.stringify(params.id)}`)
    return params.id as string

  }, 
  [params.id]);

  //const MemoizedCoachSkyler = React.memo(CoachSkyler);

  return (
    <>
      <PageTitle title={"SkylerChat"} />
      <Card>                
        <CoachSkyler chatSessionId={chatSessionId} persona={'member'}/>
      </Card>
    </>
  );
}

